import React, {FC, memo, useCallback, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {DATE_RANGE} from '../../@components'
import {DateRangeType, LoadingState} from '../../../global'
import {usePeriod} from '../../features'
import {PageHeader} from '../../@components/widgets/PageHeader'
import {Dashboard} from './Dashboard'
import {DEFAULT_DATE_RANGE} from '../../@types/global'
import {useQuery} from 'react-query'
import {Get} from '../../../setup'
import {DashboardWrapperTypes} from '../../@types'

const endpoint = process.env.REACT_APP_V2_DASHBOARD_WRAPPER || 'v2/dashboard'

const DashboardPage: FC = () => {

    const [state, setState] = useState({
        selectedDateRange: DEFAULT_DATE_RANGE,
        loading: 'idle' as LoadingState,
    });
    const period = usePeriod(state.selectedDateRange);
    const handleDateRangeChange = useCallback((dateRange: DateRangeType) => {
        setState((prev) => ({ ...prev, selectedDateRange: dateRange }));
    }, []);
    const pageHeader = useMemo(() => (
        <PageHeader
            icon={'/media/icons/duotune/animation/ani002.svg'}
            title={'Activité et performances de votre site web'}
            description={'Ce tableau de bord vous offre une vue claire et concise de l\'activité de votre site sur la période sélectionnée. Suivez vos indicateurs clés comme les visites, les conversions, les formulaires soumis et les appels téléphoniques'}
        />
    ), []);

    const { data } = useQuery([`DASHBOARD`, period],
        () => Get<DashboardWrapperTypes>({ endpoint, period }), {
            onSuccess: () => setState(prev => ({...prev, loading: 'fulfilled'})),
            keepPreviousData: true, // Avoid re-rents during recharging
        });

    return (
        <>
            {pageHeader}

            <div className="row mt-6 mt-xl-9 mb-5 d-flex justify-content-end align-items-center">
                <div className="col-12 col-sm-6 col-md-4 d-flex justify-content-end align-items-center">
                    <DATE_RANGE
                        onDateRangeChange={handleDateRangeChange}
                        loading={state.loading}
                        setLoading={(loading) => setState((prev) => ({ ...prev, loading }))}
                    />
                </div>
            </div>

            <Dashboard data={data} />
        </>
    )
}

const DashboardWrapper: FC = memo(() => {
    const intl = useIntl()
    return (
        <>
            <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
            <DashboardPage />
        </>
    )
})

export {DashboardWrapper}